import React, { useState } from "react";

import Navbar from "../components/navbar";
import Footer from "../components/footer";
import faqHeader from "../assect/images/bg/dl_curvedimgs_faqs.png";
import AvailableProperties from "../components/availableproperties";

// const faqObjs = [{
//     sectionName: "Pets",
//     sectionItems: [{
//         title: "Are pets allowed?",
//         description: "Yes! We know they’re part of the family, and we’re proud to offer a pet-friendly experience."
//     },{
//         title: "Is there a pet fee/deposit?",
//         description: "There’s a monthly pet fee per pet, which varies depending on the length of your stay."
//     }]
// },{
//     sectionName: "Furnishings and Amenities",
//     sectionItems: [{
//         title: "Do you offer furnished units?",
//         description: "Yes! We offer a variety of furnished, semi-furnished, and unfurnished units."
//     }]
// },{
//     sectionName: "Maintenance and Support",
//     sectionItems: [{
//         title: "What happens if something breaks during my stay?",
//         description: "We manage each property with care, and we take maintenance seriously. If something isn’t working, we are here to help."
//     }]
// }];


const faqObjs = [{
    sectionName: "Pets",
    sectionItems: [{
        title: "Are pets allowed?",
        description: "Yes! We know they’re part of the family, and we’re proud to offer a pet-friendly experience."
    },
    {
        title: "Is there a pet fee/deposit?",
        description: "There’s a monthly pet fee per pet, which varies depending on the length of your stay."
    }]
},
{
    sectionName: "Parking",
    sectionItems: [{
        title: "Is parking available?",
        description: "Some of our properties have off-street parking, and those that do not are close to City of Troy parking garages, which sell monthly parking permits for $75."
    }]
}, {
    sectionName: "Maintenance and Support",
    sectionItems: [{
        title: "How will I pay rent and request maintenance?",
        description: "Our property management platform is Hemlane.  Tenants can message us here (we are very reactive), make rent and other payments, see building and lease information, and request maintenance tasks."
    }, {
        title: "What happens if something breaks during my stay?",
        description: "We manage each property with care, and we take maintenance seriously. If something isn’t working, we are here to help."
    }]
}];


export default function Faqs() {
    const ListFaqs = (arrInfo) => {

        return (
            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                {
                    arrInfo.arrInfo.map((section, secIndex) => (
                        <li key={secIndex}>
                            <p style={{ fontWeight: "bold", fontSize: "13pt" }}>{section.sectionName}</p>
                            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                                {
                                    section.sectionItems.map((sItem, sIndex) => (
                                        <li key={sIndex} style={{ marginInlineStart: "0" }}>
                                            <span style={{ fontWeight: "bold", fontSize: "13pt" }}>{sItem.title}</span>
                                            <p style={{ fontSize: "13pt" }}>{sItem.description}</p>
                                        </li>
                                    ))
                                }
                            </ul>
                        </li>
                    ))
                }
            </ul>
        )
    }

    return (
        <div style={{ backgroundColor: "#f0eadd" }}>
            <Navbar navClass="defaultscroll sticky" logolight={true} menuClass="navigation-menu nav-right" />
            <div className="top-half top-half d-table w-100 pt-5">
                <section className="bg-half-116" style={{ backgroundImage: `url(${faqHeader})` }}>
                </section>
            </div>

            <section className="section-50 pb-0">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xxl-6 col-xl-7">
                            <p className="mb-sm-5 mb-4 sub_heading">Frequently Asked Questions</p>
                            <ListFaqs arrInfo={faqObjs} />
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative avaliable_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <AvailableProperties />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}